module.exports = __webpack_public_path__ + "c13797bd5e320111cf0af5c140ad9ee5.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-SemiBoldItalic.woff
// module id = 375
// module chunks = 0